module.exports = __webpack_public_path__ + "static/delphine-ec794bed9dee64d8d50c6a0919f20f58.jpg";